(() => {
  'use strict';
  const flT = globalThis.FellinoI18n.text;
  const euro = new Intl.NumberFormat((globalThis.FellinoI18n?.locale || 'de-DE'), {style:'currency',currency:'EUR'});
  const number = new Intl.NumberFormat((globalThis.FellinoI18n?.locale || 'de-DE'), {maximumFractionDigits:2});
  const points = cents => number.format(cents / 100);
  const date = t => new Date(t * 1000).toLocaleDateString((globalThis.FellinoI18n?.locale || 'de-DE'));
  const routeRoot = globalThis.FellinoI18n.root;
  const endpoint = routeRoot + 'apps/fellino-treue/proxy.php';
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const el = key => root.querySelector(`[data-${key}]`);
    const account = root.querySelector('.flp-account');
    let state = null, busy = false, requestId = null, polls = 0;
    function showError(message) { el('error').hidden=false; el('error').querySelector('span').textContent=message; }
    function render(data) {
      state=data;
      el('loading').hidden=true;
      el('anonymous').hidden=data.authenticated;
      el('join').hidden=!data.authenticated || data.member;
      el('dashboard').hidden=!data.authenticated || !data.member;
      el('history-section').hidden=!data.authenticated || !data.member;
      if (!data.authenticated || !data.member) return;
      const balance=data.balance, spendable=Math.max(0,balance/100);
      el('balance').textContent=points(balance);
      el('value').textContent=balance>=0 ? flT("s1aa1cbf67448")+euro.format(balance/100)+flT("s336e4257b4be") : flT("s0a7734656570");
      el('meter').style.width=Math.min(100,Math.max(0,balance))+'%';
      el('progress-copy').textContent=spendable ? euro.format(spendable)+flT("sd5f05c0377ba") : flT("sc0b5daaa5d3f");
      el('pending').textContent=points(data.pending);
      el('pending').parentElement.hidden=!data.pending;
      el('release').textContent=data.nextRelease ? flT("s839402fe1ab6")+date(data.nextRelease) : '';
      const rewards=data.rewards || (data.reward ? [data.reward] : []);
      const pendingReward=rewards.some(r=>r.state!=='active');
      el('redeem').hidden=spendable<0.01 || pendingReward;
      if (spendable && !pendingReward) {
        const input=root.querySelector('#flp-reward-amount');
        input.max=Math.min(spendable,1000).toFixed(2);
        input.value=input.max;
      }
      el('reward').hidden=!rewards.length;
      el('shop-link').hidden=!!rewards.length;
      el('reward').replaceChildren();
      for (const reward of rewards) {
        const ready=reward.state==='active';
        const card=document.createElement('div'),title=document.createElement('strong'),copy=document.createElement('p');
        card.className='flp-reward-active';
        title.textContent=ready ? flT("sc0b78282e699")+euro.format(reward.points/100)+flT("s0b841c43b2b4") : flT("sa56e6adae9a3");
        copy.textContent=ready ? flT("sff8bd639695b") : flT("s16a117491f74");
        card.append(title,copy);
        if(ready) {
          const code=document.createElement('code'),link=document.createElement('a');
          code.dataset.rewardCode='';code.textContent=reward.code;
          link.dataset.rewardLink='';link.className='flp-button';link.href=routeRoot+'discount/'+encodeURIComponent(reward.code)+'?redirect='+encodeURIComponent(routeRoot+'cart');link.textContent=flT("s0dd30626ad62");
          card.append(code,link);
        }
        el('reward').append(card);
      }
      if(pendingReward && polls++<5) setTimeout(()=>load(),4000);
      el('sync').textContent=data.lastSync ? flT("s2eb4c938af37")+new Date(data.lastSync*1000).toLocaleTimeString((globalThis.FellinoI18n?.locale || 'de-DE'),{hour:'2-digit',minute:'2-digit'})+flT("s4e2866d1f2b9") : flT("s37a9f91dfe86");
      if(data.lastSync && Date.now()/1000-data.lastSync>180) el('sync').textContent=flT("sca847f833173");
      el('history').replaceChildren();
      const rows=[...data.pendingOrders.map(o=>({reason:flT("s5ee7fb8e98f2")+o.name,detail:flT("s3250c15eac4d")+date(o.available_at),value:points(o.points)+flT("s142781f31575")})),...data.history.map(h=>({reason:globalThis.FellinoI18n.history(h.reason),detail:date(h.created),value:(h.delta>0?'+':'')+points(h.delta)+flT("s142781f31575")}))];
      rows.forEach(row=>{const li=document.createElement('li'),label=document.createElement('span'),detail=document.createElement('small'),value=document.createElement('b');label.textContent=row.reason;detail.textContent=row.detail;label.append(detail);value.textContent=row.value;li.append(label,value);el('history').append(li);});
      el('empty-history').hidden=rows.length>0;
    }
    async function request(payload) {
      if(busy) return;
      busy=true; account.setAttribute('aria-busy','true');
      root.querySelectorAll('button').forEach(b=>b.disabled=true);el('error').hidden=true;
      try {
        const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),30000);
        let response;
        try { response=await fetch(endpoint,{method:payload?'POST':'GET',cache:'no-store',credentials:'same-origin',signal:controller.signal,...(payload?{headers:{'Content-Type':'application/json'},body:JSON.stringify({...payload,csrf:state?.csrf})}:{})}); }
        finally {clearTimeout(timer);}
        if(!response.headers.get('content-type')?.includes('application/json')) throw new Error(flT("s66cbbabe67c4"));
        const data=await response.json();
        if(!response.ok || data.error) throw new Error(globalThis.FellinoI18n.source(data.error) || flT("sf1a8874a7f1f"));
        render(data);
        if(payload?.action==='redeem' || (!payload && !data.reward)) requestId=null;
      } catch(error) { el('loading').hidden=true;showError(error.name==='AbortError'?flT("s22b932edd3d5"):error.message); }
      finally {busy=false;account.setAttribute('aria-busy','false');root.querySelectorAll('button').forEach(b=>b.disabled=false);}
    }
    function load(){return request();}
    el('retry').addEventListener('click',load);
    el('join').addEventListener('submit',async event=>{event.preventDefault();if(!el('join').reportValidity())return;await request({action:'join',terms:state?.terms});});
    el('redeem').addEventListener('submit',async event=>{event.preventDefault();if(!state?.member||!el('redeem').reportValidity())return;requestId ||= crypto.randomUUID();await request({action:'redeem',points:Math.round(Number(root.querySelector('#flp-reward-amount').value)*100),requestId});});
    root.querySelectorAll('[data-open-terms]').forEach(link=>link.addEventListener('click',()=>root.querySelector('#teilnahmebedingungen').open=true));
    load();
  }
  document.querySelectorAll('[data-fellino-loyalty]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-fellino-loyalty]').forEach(mount));
})();
